import { Schooladvies } from '@models/schooladvies.model';

export interface SchooladviezenStateModel {
  schooladviezen: Schooladvies[];
  loading: boolean;
  error: string | null;
  loaded: boolean;
}

export const SchooladviezenInitialState = {
  schooladviezen: [] as Schooladvies[],
  loading: false,
  error: null,
  loaded: false,
};
